<template src="./FeedbackForm.html"></template>

<script>
import showStatus from "../NetworkManager/showStatus";
import feedbackService from "../services/feedbackService";
import { formatDate, formatUtcDateTime } from "../utils/date";
import StudentLogin from "./StudentLogin.vue";
import FeedbackDetails from "./FeedbackDetails.vue";
import FeedbackQuestions from "./FeedbackQuestions.vue";
import FeedbackPreview from "./FeedbackPreview.vue";
import FeedbackThankYou from "./FeedbackThankYou.vue";

const INPUT_TYPES = {
  "Single Select": "rating",
  "Multi Select": "checkbox",
  "Multiple Select": "checkbox",
  Radio: "radio",
  Checkbox: "checkbox",
  Rating: "rating",
  Text: "text",
  Textarea: "textarea",
};

export default {
  name: "FeedbackForm",

  components: {
    StudentLogin,
    FeedbackDetails,
    FeedbackQuestions,
    FeedbackPreview,
    FeedbackThankYou,
  },

  data: () => ({
    backgroundColor: "#E1E2F8",
    instituteId: "",
    instituteLogo: "",
    formUniqueUrlId: "",
    formId: "",
    loading: true,
    formTitle: "",
    dueDate: "",
    startDate: "",
    cbIsNBACriteriaAttainment: "",
    selectedAns: "",
    questionList: [],
    qOptions: [],
    response: [],
    invalidUrl: "INVALID_URL",
    loadError: "",
    formType: "",
    feedback: [],
    feedbackForm: [],
    allStudents: [],
    name: "",
    email: "",
    uId: "",
    formDescription: "",
    valid: false,
    emailchecked: null,
    isSubjectPresent: null,
    responsechecked: false,
    isShow: null,
    isSubmit: false,
    feedbackMessage: "",
    feedbackMessageType: "",
    isCourseAvaliable: null,
    collegePRNNo: "",
    fullName: "",
    isSingleForAllCourse: "",
    isAllowToSubmitData: undefined,
    isLoadingData: false,
    isFeedbackClosed: null,
    isFeedbackAvailable: null,
    errorMessages: [],
    isEmailValidate: false,
    errorDialog: false,
    isQuestionAvailable: null,
    isVisible: false,
    department: "",
    courseYear: "",
    semName: "",
    step: "login",
    prn: "",
    batch: "",
    academicYear: "",
    activeSubjectIndex: 0,
    submitting: false,
    submittedAt: null,
    prnChecked: null,
    isExcluded: null,
    studentSpecializations: [],
  }),

  computed: {
    emailRules() {
      return [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ];
    },

    subjectCount() {
      return this.feedback?.courses?.length || 0;
    },

    isRecruiterFeedback() {
      return this.formType === "Recruiter Feedback";
    },

    isSuccessMessage() {
      return this.feedbackMessageType === "success";
    },
  },

  created() {
    this.getFormId();
  },

  methods: {
    async getInstituteLogo() {
      try {
        const res = await feedbackService.getInstituteBranding(
          this.instituteId
        );
        this.instituteLogo = res.instituteLogoLink;
      } catch (e) {
        console.error(e);
      }
    },

    // The form id is the last path segment. Read it off `pathname` rather than the
    // full href so a shared link carrying tracking params (?utm_source=…) or a hash
    // does not drag them into the id; empty segments cover the trailing-slash case.
    getFormId() {
      const segments = window.location.pathname
        .split("/")
        .filter((segment) => segment !== "");

      if (segments.length === 0) {
        this.invalidUrl = "INVALID_URL";
        this.loading = false;
        return;
      }

      this.formUniqueUrlId = decodeURIComponent(segments[segments.length - 1]);
      this.invalidUrl = "FORM_INPROGRESS";
      this.getFormDetails();
    },

    resolveDueDate(feedbackData) {
      const extended =
        feedbackData.extendedDate || feedbackData.extendedDateTime;
      const isValidExtension = extended && !isNaN(new Date(extended).getTime());

      return isValidExtension ? extended : feedbackData.endDate;
    },

    isPastTime(isoTime) {
      const inputTime = new Date(isoTime);
      const currentTime = new Date();

      return inputTime < currentTime;
    },

    UTCtoISTFormat(startDate) {
      // Convert to a Date object in UTC
      const utcDate = new Date(startDate);

      // Convert to IST (UTC +5:30)
      const istOffset = 5.5 * 60 * 60 * 1000; // 5.5 hours in milliseconds
      const istDate = new Date(utcDate.getTime() + istOffset);

      // The shifted value carries the IST wall clock in its UTC fields, so read
      // it back in UTC — as DD/MM/YYYY, like every other date in this module.
      return formatUtcDateTime(istDate);
    },

    toInputType(selectedType) {
      return INPUT_TYPES[selectedType] || "rating";
    },

    buildQuestion(question) {
      const selectedType = question?.scales?.selectedType;
      const inputType = this.toInputType(selectedType);

      return {
        questionId: question.questionId,
        questionNumber: question.questionNumber,
        questionStatement: question.questionStatement,
        selectedType,
        inputType,
        selectedAnswer: inputType === "checkbox" ? [] : "",
        errorMessage: "",
        cos: question.mappedCOPO || question.selectedCos || [],
        selectedPso: question.selectedPso || [],
        specialization: question.specialization || "",
        options: (question?.scales?.scale || []).map((obj) => ({
          number: obj.scaleNumber,
          label: obj.scaleLabel,
        })),
      };
    },

    async getFormDetails() {
      try {
        console.log('this.formUniqueUrlIdk', this.formUniqueUrlId);
        const res = await feedbackService.getFeedback(this.formUniqueUrlId);

        if (res.feedback?.length > 0) {
          const feedbackData = res.feedback[0];
          const dueDate = this.resolveDueDate(feedbackData);

          this.isFeedbackClosed = this.isPastTime(dueDate);
          this.isFeedbackAvailable = this.isPastTime(feedbackData.startDate);

          this.startDate = this.UTCtoISTFormat(feedbackData.startDate);
          this.instituteId = feedbackData.instituteId;
          this.formType = feedbackData.formType;
          this.feedback = feedbackData;
          this.formId = feedbackData._id;
          this.formTitle = feedbackData.formTitle;
          this.formDescription = feedbackData.formDescription;
          this.isSingleForAllCourse = feedbackData.setting.isSingleForAllCourse;
          this.dueDate = formatDate(dueDate);
          this.department = this.feedback.department;
          this.courseYear = this.feedback.courseYear;
          this.academicYear = this.feedback.academicYear;
          this.batch = await this.resolveBatchName();
          this.semName = await this.getSemesterDetails(
            this.instituteId,
            feedbackData.semId
          );
          // for STMIRAS
          this.isVisible =
            "6604982c-cc08-4e00-81fb-a375a10b72e4" === this.instituteId
              ? true
              : false;

          this.isCourseAvaliable =
            this.formType === "Course Feedback" &&
            this.feedback?.courses?.length > 0
              ? true
              : false;
          if (this.isCourseAvaliable) {
            await this.getFacultyName();
          }

          const extractQuestions = (questions, res = []) => {
            questions.forEach((question) => {
              if (question.question && question.question.length > 0) {
                extractQuestions(question.question, res);
              } else {
                res.push(this.buildQuestion(question));
              }
            });
          };

          if (this.isCourseAvaliable) {
            this.feedbackForm = this.feedback.courses.map((course) => {
              const res = [];

              extractQuestions(course?.allQuestions || [], res);

              return {
                subjectId: course.subjectId,
                subjectCode: course.subjectCode,
                subjectName: course.subjectName,
                sectionName: "",
                questions: res,
                facultyDetails: course.facultyDetails || [],
                excludedStudents: course.excludedStudents || [],
              };
            });
          } else {
            const res = [];

            extractQuestions(this.feedback.allQuestions || [], res);
            this.feedbackForm = res;
          }

          this.refreshQuestionAvailability();
          this.getInstituteLogo();

          if (this.formId === undefined) {
            this.invalidUrl = "INVALID_URL";
          }
        } else {
          this.invalidUrl = "INVALID_URL";
        }

        this.loading = false;
      } catch (err) {
        // The request itself failed (network, CORS, 5xx). That is not the same thing
        // as "there is no such form" — reporting both as INVALID_URL is what made this
        // screen impossible to diagnose.
        this.loading = false;
        this.invalidUrl = "LOAD_FAILED";
        this.loadError = this.describeError(err);
        showStatus(err, 6000, "error", this);
      }
    },

    describeError(err) {
      const status = err?.response?.status;

      if (status) {
        return `The server responded with ${status}.`;
      }

      return err?.message || "The server could not be reached.";
    },

    retryLoad() {
      this.invalidUrl = "FORM_INPROGRESS";
      this.loadError = "";
      this.loading = true;
      this.getFormDetails();
    },

    // Resolve the human-readable batch name (e.g. "Batch 2021-2025") from the
    // feedback's department + course year + academic year. The name already carries
    // its own "Batch" label, so nothing is prefixed here. Falls back to the stored
    // batch field when no matching batch is found (or the lookup fails).
    async resolveBatchName() {
      try {
        const res = await feedbackService.getBatchName({
          lmsInstituteId: this.instituteId,
          department: this.feedback.department,
          courseYear: this.feedback.courseYear,
          academicYear: this.feedback.academicYear,
        });
        return res?.batchName || this.feedback.batch || "";
      } catch (e) {
        console.error(e);
        return this.feedback.batch || "";
      }
    },

    refreshQuestionAvailability() {
      this.isQuestionAvailable = this.isCourseAvaliable
        ? this.feedbackForm.some((subject) => subject.questions.length > 0)
        : this.feedbackForm.length > 0;
    },

    async getFacultyName() {
      try {
        const data = await feedbackService.getDivisionAndFacultiesForSubject({
          instituteId: this.feedback.instituteId,
          semId: this.feedback.semId,
          department: this.feedback.department,
          courseYear: this.feedback.courseYear,
        });
        this.feedback?.courses?.map((item1) => {
          let facultyDetails = [];
          data?.subjects?.map((item2) => {
            if (item1.subjectId === item2.subjectId) {
              if (item2.name !== "-") {
                facultyDetails.push({
                  name: item2.name,
                  division: item2.division,
                });
              }
            }
          });
          item1.facultyDetails = facultyDetails;
        });
      } catch (e) {
        console.error(e);
      }
    },

    onLogin({ prn, email }) {
      this.prn = prn;
      this.email = email;
      this.validateData();
    },

    async validateData() {
      this.feedbackMessage = "";
      this.isLoadingData = true;
      this.prnChecked = null;
      this.isExcluded = null;

      // Recruiter Feedback is anonymous: recruiters are not registered users, so a
      // valid email is enough and no account / PRN / enrolment checks apply.
      if (this.isRecruiterFeedback) {
        this.uId = "";
        this.collegePRNNo = "";
        this.fullName = "";
        this.emailchecked = true;
        this.prnChecked = true;
        this.isExcluded = false;
        this.isSubjectPresent = true;
        this.responsechecked = false;
        await this.finalChecking();
        return;
      }

      const isAuthorized = await this.CheckEmail();

      if (!isAuthorized) {
        this.emailchecked = false;
        this.isSubjectPresent = false;
        this.isLoadingData = false;
      }
      if (isAuthorized) {
        await this.getUsers();
        this.prnChecked = this.checkPRN();

        if (this.prnChecked) {
          this.isExcluded = this.checkExclusion();

          if (!this.isExcluded) {
            const isSubjectApplicable = await this.checkedSubjectIsApplicable();

            if (!isSubjectApplicable) {
              this.isSubjectPresent = false;
              this.isLoadingData = false;
            }
            const isResponseAvailable = await this.checkedResponseIsAvaliable();
            if (!isResponseAvailable) {
              this.responsechecked = false;
            }
          }
        }
      }
      await this.finalChecking();
    },

    checkExclusion() {
      if (!this.isCourseAvaliable) {
        return (this.feedback.excludedStudents || []).includes(this.uId);
      }

      this.feedbackForm = this.feedbackForm.filter(
        (subject) => !subject.excludedStudents.includes(this.uId)
      );
      this.refreshQuestionAvailability();

      return this.feedbackForm.length === 0;
    },

    checkPRN() {
      const entered = (this.prn || "").trim().toLowerCase();
      const registered = (this.collegePRNNo || "").trim().toLowerCase();

      return !!registered && entered === registered;
    },

    async CheckEmail() {
      try {
        this.uId = "";

        // Fetch user authentication by email
        const response = await feedbackService.login(this.email.trim());
        // Check if user authentications exist
        if (response?.userAuthentications?.length > 0) {
          const { uId } = response.userAuthentications[0];
          this.uId = uId;
          this.emailchecked = true;

          return true;
        }
        return false;
      } catch (e) {
        console.error(e);
        return false;
      }
    },

    async getUsers() {
      try {
        // Fetch user details
        const users = await feedbackService.getUsers([this.uId]);
        this.collegePRNNo = users.users[0]?.collegePRNNo || "";
        this.fullName = `${users.users[0]?.firstName || ""} ${
          users.users[0]?.middleName || ""
        } ${users.users[0]?.lastName || ""}`.trim();
      } catch (e) {
        console.error(e);
        return false;
      }
    },

    async getSemesterDetails(instituteId, semId) {
      try {
        const res = await feedbackService.getSemesterDetails(
          instituteId,
          semId
        );
        return res?.semesters[0]?.semName || "";
      } catch (e) {
        console.error(e);
      }
    },
    async checkedSubjectIsApplicable() {
      try {
        const objToPush = {
          semId: this.feedback.semId,
          // department: this.feedback.department,
          uId: this.uId,
        };

        if (this.isCourseAvaliable) {
          objToPush.courseYear = this.feedback.courseYear;
          objToPush.subjectIds =
            this.feedback?.courses?.map((item) => item.subjectId) || [];
        }
        const { semesterUsers, subjectDetails } =
          await feedbackService.getAllocatedSubjectsWithOtherDepartments(
            objToPush
          );

        if (semesterUsers?.length > 0) {
          this.studentSpecializations = this.collectSpecializations(
            subjectDetails,
            semesterUsers
          );

          if (!this.isCourseAvaliable) {
            this.filterPsoQuestions();
          }

          if (this.isCourseAvaliable && objToPush.subjectIds.length) {
            const availableSubjects = new Set(
              semesterUsers
                .flatMap((user) => [
                  ...(user.subjects || []),
                  ...(user.otherDepartmentSubjects || []),
                ])
                .filter((subject) => objToPush.subjectIds.includes(subject))
            );

            const finalSub = this.feedbackForm.filter((item) =>
              availableSubjects.has(item.subjectId)
            );
            this.feedbackForm = finalSub;
          }
          this.refreshQuestionAvailability();
          this.isSubjectPresent = semesterUsers.length > 0 ? true : false;
          return true;
        } else {
          this.isSubjectPresent = false;
        }
      } catch (e) {
        console.error(e);
        this.isSubjectPresent = false;
        return false;
      }
    },

    normalizeSpecialization(value) {
      return String(value || "")
        .trim()
        .toLowerCase();
    },

    // A subject carries `specializations` (an array), so a student assigned to several
    // subjects can span several specializations. Falls back to the semesterUser's own
    // specialization when the assigned subjects carry none.
    collectSpecializations(subjectDetails, semesterUsers) {
      const fromSubjects = (subjectDetails || []).flatMap(
        (subject) => subject.specializations || []
      );

      const specializations = fromSubjects.length
        ? fromSubjects
        : semesterUsers.map((user) => user.specialization);

      return [
        ...new Set(
          specializations
            .map(this.normalizeSpecialization)
            .filter((value) => value !== "")
        ),
      ];
    },

    // Program Exit only. PO-mapped questions are untouched; a PSO-mapped question is shown
    // only when its specialization is one of the student's. PSO numbers repeat across
    // specializations, so the specialization string is the only thing that disambiguates them.
    filterPsoQuestions() {
      const studentSpecializations = new Set(this.studentSpecializations);

      this.feedbackForm = this.feedbackForm.filter((question) => {
        const isPsoQuestion = (question.selectedPso || []).length > 0;

        if (!isPsoQuestion) return true;

        return studentSpecializations.has(
          this.normalizeSpecialization(question.specialization)
        );
      });

      this.refreshQuestionAvailability();
    },
    async checkedResponseIsAvaliable() {
      try {
        const objToPush = {
          feedbackFormId: this.feedback.feedbackId,
          uId: this.uId,
        };
        if (this.isCourseAvaliable) {
          objToPush["subjectIds"] = this.feedback.courses.map(
            (item) => item.subjectId
          );
        }
        const res = await feedbackService.getFeedbackResponseByUId(objToPush);
        this.responsechecked = res.feedbacks.length > 0 ? true : false;
        return true;
      } catch (e) {
        console.error(e);
        this.responsechecked = false;
        return false;
      }
    },

    async finalChecking() {
      this.isShow =
        this.emailchecked &&
        this.prnChecked &&
        !this.isExcluded &&
        !this.responsechecked &&
        this.isSubjectPresent;

      if (this.emailchecked && this.prnChecked && this.isExcluded) {
        this.feedbackMessage =
          "You are not able to login. Please contact admin.";
        this.feedbackMessageType = "error";
        this.errorDialog = true;
        this.isLoadingData = false;
        return;
      }

      if (
        this.emailchecked &&
        this.prnChecked &&
        this.isSubjectPresent &&
        this.responsechecked
      ) {
        this.feedbackMessage = "The response has already been taken!";
        this.feedbackMessageType = "success";
        this.errorDialog = true;
      }
      if (this.emailchecked && this.prnChecked === false) {
        this.feedbackMessage =
          "Invalid PRN. Please enter the PRN registered for this email ID.";
        this.feedbackMessageType = "error";
        this.errorDialog = true;
      }
      if (!this.emailchecked) {
        this.feedbackMessage =
          "Invalid email ID. This email is not registered - please enter your institute email ID exactly as registered.";
        this.feedbackMessageType = "error";
        this.errorDialog = true;
      }
      if (this.emailchecked && this.prnChecked && !this.isSubjectPresent) {
        this.feedbackMessage =
          "You are not enrolled for the subjects in this feedback form.";
        this.feedbackMessageType = "error";
        this.errorDialog = true;
      }

      if (this.isShow) {
        this.activeSubjectIndex = 0;
        this.step = "details";
      }

      this.isLoadingData = false;
    },

    onEditSubject(index) {
      this.activeSubjectIndex = index;
      this.step = "questions";
    },

    onDone() {
      window.location.reload();
    },

    checkSelectedAnswers(data) {
      let allAnswersFilled = true;

      if (this.isCourseAvaliable) {
        for (const subject of data) {
          for (const question of subject.questions) {
            // Check if selectedAnswer is an empty array or an empty string
            if (
              (Array.isArray(question.selectedAnswer) &&
                question.selectedAnswer.length === 0) ||
              (typeof question.selectedAnswer === "string" &&
                question.selectedAnswer === "")
            ) {
              question.errorMessage = "This is a required question.";
              allAnswersFilled = false;
            } else {
              question.errorMessage = "";
            }
          }
        }
      } else {
        for (const subject of data) {
          // Check if selectedAnswer is an empty array or an empty string
          if (
            (Array.isArray(subject.selectedAnswer) &&
              subject.selectedAnswer.length === 0) ||
            (typeof subject.selectedAnswer === "string" &&
              subject.selectedAnswer === "")
          ) {
            subject.errorMessage = "This is a required question.";
            allAnswersFilled = false;
          } else {
            subject.errorMessage = "";
          }
        }
      }

      return allAnswersFilled;
    },

    async submitFeedbackResponse() {
      if (this.submitting) return;

      this.isAllowToSubmitData = this.checkSelectedAnswers(this.feedbackForm);

      if (!this.isAllowToSubmitData) {
        this.feedbackMessage = "Please answer all the required questions.";
        this.feedbackMessageType = "error";
        this.errorDialog = true;
        this.step = "questions";
        return;
      }

      this.submitting = true;

      try {
        let response = [];
        let objToPush = {
          candidateFullName: this.fullName,
          candidateEmailId: this.email.trim(),
          feedbackFormId: this.formUniqueUrlId,
        };
        // Anonymous (recruiter) responses carry no uId so they are not tied to a user.
        if (!this.isRecruiterFeedback) {
          objToPush.uId = this.uId;
        }

        const mapQuestions = (questions) =>
          questions.map((question) => ({
            answer: question.selectedAnswer,
            questionId: question.questionId,
            questionNumber: question.questionNumber,
          }));

        if (this.isCourseAvaliable) {
          response = this.feedbackForm.map((subject) => ({
            ...objToPush,
            subjectId: subject.subjectId,
            studentResponse: mapQuestions(subject.questions),
          }));
        } else {
          let studentResponse = mapQuestions(this.feedbackForm);
          response.push({
            ...objToPush,
            studentResponse,
          });
        }

        await feedbackService.submitFeedback(this.formUniqueUrlId, response);

        this.invalidUrl = "FORM_SUBMITTED_SUCCESS";
        this.isSubmit = true;
        this.submittedAt = new Date();
        this.step = "thankyou";
        showStatus("Form submitted Successfully!!", 6000, "success", this);
      } catch (err) {
        this.feedbackMessage =
          "We could not submit your feedback. Please check your connection and try again.";
        this.feedbackMessageType = "error";
        this.errorDialog = true;
        showStatus(err, 6000, "error", this);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style src="./FeedbackForm.css" scoped></style>
